import { ChevronDown, ChevronRight } from "lucide-react";
import { GROUP_HEADER_HEIGHT } from "@/common/constants";
import { Button } from "@/components/ui/button";
import type { RowGroup } from "./RowModel";
import type { TableModel } from "./useTableModel";

interface TaskListGroupHeaderProps {
    tableModel: TableModel;
    rowGroup: RowGroup;
    isExpanded: boolean;
    onExpand: (rowGroup: RowGroup) => void;
}

export default function TaskTableGroupHeader({ tableModel, rowGroup, isExpanded, onExpand }: TaskListGroupHeaderProps) {
    return (
        <div className="w-full flex items-end table-group-header" style={{ height: `${GROUP_HEADER_HEIGHT}px` }}>
            <div className="select-none px-4 pl-1.5 flex items-center  font-medium text-gray-900 pb-2">
                <Button
                    variant="ghost"
                    size="icon"
                    className="mr-1.5"
                    onClick={() => {
                        onExpand(rowGroup);
                    }}
                >
                    {isExpanded ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                </Button>
                <div className="flex items-center gap-2">{tableModel.groupColumn!.getGroupHeader({ row: rowGroup.firstRow })}</div>
            </div>
        </div>
    );
}
